
export default function RoofingServices() {
  const services = [
    {
      icon: 'ri-sun-line',
      title: 'Best Roofing Materials for El Paso Sun',
      description: `El Paso receives over 300 days of sunshine annually with intense UV radiation that can degrade inferior roofing materials. The best options include cool roof shingles with high solar reflectance, clay or concrete tiles that naturally resist heat, and metal roofing with reflective coatings. These materials can reduce cooling costs by 15-25% while lasting 30-50 years in our climate. Avoid organic asphalt shingles that deteriorate quickly under constant sun exposure.`
    },
    {
      icon: 'ri-windy-line',
      title: 'Wind-Resistant Roofing Solutions',
      description: `El Paso experiences frequent high winds, especially during spring months, with gusts exceeding 50 mph. Proper installation is critical—contractors must use enhanced fastening patterns, sealed shingles, and reinforced underlayment. Look for materials rated for 110+ mph wind resistance. Metal roofing and properly installed architectural shingles perform best. Edge flashing and drip edges must be securely fastened to prevent wind uplift that leads to catastrophic failure.`
    },
    {
      icon: 'ri-hail-line',
      title: 'Understanding Hail Damage Claims in El Paso',
      description: `While less frequent than other Texas cities, El Paso does experience hail events that can damage roofs. After a hailstorm, schedule a professional inspection within 30 days. Document all damage with photos and measurements. Most homeowners insurance policies cover hail damage with depreciation considerations. Reputable contractors will work directly with your insurance adjuster and provide detailed estimates. Beware of storm chasers—verify contractor licensing and local references before signing contracts.`
    },
    {
      icon: 'ri-drop-line',
      title: 'Desert Climate Waterproofing',
      description: `Despite low annual rainfall (8-9 inches), El Paso's monsoon season brings intense downpours that test roof drainage systems. Proper waterproofing includes quality underlayment, sealed valleys, and adequate flashing around penetrations. Flat or low-slope roofs common in southwestern architecture require specialized membrane systems like TPO or modified bitumen. Poor drainage leads to ponding water that accelerates deterioration and causes interior leaks.`
    },
    {
      icon: 'ri-temp-hot-line',
      title: 'Thermal Expansion Management',
      description: `El Paso's extreme temperature swings—from below freezing in winter to 105°F+ in summer—cause significant thermal expansion and contraction. This stress cracks inferior materials and loosens fasteners over time. Quality installations account for expansion with proper spacing, flexible sealants, and expansion joints. Metal roofing requires special clips that allow movement. Contractors experienced with desert conditions understand these critical details that prevent premature failure.`
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Energy Efficiency and Cool Roofing',
      description: `Energy-efficient roofing is essential in El Paso where cooling costs dominate utility bills. Cool roof technology reflects solar radiation and emits absorbed heat, keeping attic temperatures 30-50°F cooler. Options include white or light-colored metal roofing, special reflective shingles, and tile roofing. Combined with proper attic ventilation and insulation, cool roofing can reduce air conditioning costs by 20-40%. Many qualify for energy efficiency rebates from El Paso Electric.`
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Roofing Services Specific to El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            El Paso's unique desert climate, intense sun exposure, and occasional severe weather require specialized roofing knowledge. Our featured contractors understand these local challenges and provide solutions tailored to protect your home.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-700 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
